export const createURL = (root, sportType, marketName, streamType) => {
    if (!marketName && streamType) {
        return `${root}/${sportType}/${streamType}`; // Tenis - Voleybol
    } else if (streamType) {
        return `${root}/${sportType}/${streamType}/${marketName}`; // Diğer programlar
    } else {
        return `${root}/${sportType}/${marketName}`; // MarketList giriş
    }
};

export const createMultipleScreenURL = (type) => {
    return `/${type}-ekran`;
};